export default __webpack_public_path__ + "static/media/af.39e74801.svg";